import React from 'react';

import HarGhar2025 from 'views/HarGhar2025';

const SchoolProgrampage = () => {
  return <HarGhar2025 />;
};

export default SchoolProgrampage;